module.exports = __webpack_public_path__ + "static/media/ET068 new.617c6353.jpg";